import { CheckCircle2 } from 'lucide-react';

const DivisionSection = ({ id, icon: Icon, label, title, tagline, story, mission, children, reverse, square }) => (
  <section id={id} className={`section-padding ${reverse ? 'bg-white' : 'bg-[#FDFBF7]'}`}>
    <div className="container-custom">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        <div className={reverse ? 'lg:order-2' : ''}>
          <div className="flex items-center gap-3 mb-4">
            <Icon size={24} className="text-[#C5A880]" />
            <span className="overline">{label}</span>
          </div>
          <h2 className="font-heading text-3xl sm:text-4xl tracking-tight leading-tight mb-6">{title}</h2>
          <p className="text-[#5A5A5A] leading-relaxed mb-6 text-sm italic border-l-2 border-[#C5A880] pl-4">{story}</p>
          {children}
          <div className={`p-6 ${reverse ? 'bg-[#F5F3EF]' : 'bg-white border border-[#E5E0D8]'} mb-6`}>
            <h4 className="text-xs uppercase tracking-[0.15em] font-semibold text-[#1A1A1A] mb-2">Mission</h4>
            <p className="text-[#5A5A5A]">{mission}</p>
          </div>
        </div>
        <div className={`${reverse ? 'lg:order-1' : ''} aspect-square bg-[#1A1A1A] flex items-center justify-center p-12`}>
          <div className="text-center">
            <Icon size={64} className="text-[#C5A880] mx-auto mb-6" />
            <span className="font-heading text-4xl text-[#FDFBF7]">{square || title.split(' ').pop()}</span>
            <p className="text-sm text-[#9A9A9A] mt-2">{tagline}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

const BulletList = ({ title, items }) => (
  <div className="mb-6">
    <h4 className="text-xs uppercase tracking-[0.15em] font-semibold text-[#1A1A1A] mb-3">{title}</h4>
    <ul className="space-y-2">
      {items.map((item) => (
        <li key={item} className="flex items-start gap-2 text-[#5A5A5A] text-sm">
          <span className="w-1.5 h-1.5 rounded-full bg-[#C5A880] mt-2 flex-shrink-0" />
          {item}
        </li>
      ))}
    </ul>
  </div>
);

const TagList = ({ items, dark }) => (
  <div className="flex flex-wrap gap-2 mt-3 mb-8">
    {items.map((item) => (
      <span key={item} className={`text-xs px-3 py-1.5 leading-tight whitespace-nowrap ${dark ? 'bg-[#1A1A1A] text-[#FDFBF7]' : 'border border-[#E5E0D8] text-[#5A5A5A]'}`}>
        {item}
      </span>
    ))}
  </div>
);

const PillarCard = ({ pillar }) => (
  <div className="card-luxury">
    <div className="w-14 h-14 mb-6 flex items-center justify-center border border-[#C5A880]">
      <pillar.icon size={24} className="text-[#C5A880]" />
    </div>
    <h3 className="font-heading text-xl mb-2">{pillar.title}</h3>
    <p className="text-[#5A5A5A] text-sm mb-6">{pillar.description}</p>
    <ul className="space-y-2 mb-6">
      {pillar.items.map((item) => (
        <li key={item} className="flex items-start gap-2 text-sm">
          <CheckCircle2 size={14} className="text-[#C5A880] flex-shrink-0 mt-1" />
          <span className="text-[#5A5A5A]">{item}</span>
        </li>
      ))}
    </ul>
    <div className="pt-4 border-t border-[#E5E0D8]">
      <p className="text-xs text-[#C5A880] uppercase tracking-wider">Goal</p>
      <p className="text-sm text-[#1A1A1A] font-medium">{pillar.goal}</p>
    </div>
  </div>
);

export { DivisionSection, BulletList, TagList, PillarCard };
